const previewModal = {
    header: 'Podgląd',
    cancel: 'WRÓĆ',
    preview: 'Podgląd',
    tooltip: 'Zapisz zmiany, aby podejrzeć zmienione zdjęcie i tekst',
};

export default previewModal;